import angular from "angular";
import uiRouter from "angular-ui-router";
import routing from "./main.routes";
import login from "../account/login/login.component";

export class MainController {
  user = {};

  /*@ngInject*/
  constructor($http, $location, Auth, $state, LanguageService) {
    "ngInject";
    this.$http = $http;
    this.location = $location;
    this.ls = LanguageService;

    Auth.isLoggedIn().then((is) => {
      if (!is) {
        return;
      }
      $state.go("permission");
      return;
    });

    this.parameters = $location.search();
    if (this.parameters && this.parameters.data) {
      this.forgottenView = true;
      this.resetPasswordView = true;
    }
  }
}

export default angular
  .module("dalApp.main", [uiRouter, login])
  .config(routing)
  .component("main", {
    template: require("./main.html"),
    controller: MainController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js